"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formik = require("formik");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Error = function Error(_ref) {
  var error = _ref.error,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, typeof error === 'string' ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "error-text text-danger font-italic mt-2",
    role: "alert",
    "data-testid": "error-".concat(name.toLowerCase().replaceAll(' ', '-'))
  }, error) : /*#__PURE__*/_react["default"].createElement(_formik.ErrorMessage, {
    name: name
  }, function (msg) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "error-text text-danger font-italic mt-2",
      role: "alert",
      "data-testid": "error-".concat(name.toLowerCase().replaceAll(' ', '-'))
    }, msg);
  }));
};

Error.displayName = 'Error';
Error.propTypes = {
  error: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool])
};
var _default = Error;
exports["default"] = _default;